import { createApp } from 'vue'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
import ToastService from 'primevue/toastservice'
import ConfirmationService from 'primevue/confirmationservice'
import Tooltip from 'primevue/tooltip'

import App from './App.vue'
import { useAuthStore } from '@/stores/auth'
import { createAppRouter } from './router'
import { registerAuthGuards } from './router/guards'
import { vigiarVersionNueva } from './services/version'
import { esLocale } from './locales/es'
import './style.css'

const router = registerAuthGuards(createAppRouter())
const pinia = createPinia()

const app = createApp(App)

app.use(pinia)

// La restauración de la sesión arranca aquí y no en el montaje de `App.vue`: así
// la petición va en vuelo mientras Vue monta, en vez de esperar a que el primer
// componente exista. La guard espera a esta misma promesa, de modo que arriving
// tarde ya no tira a nadie al login.
void useAuthStore().initialize()

// Vigilancia de build nuevo: si alguien despliega mientras la pestaña está
// abierta, se recarga sola en vez de seguir con la versión anterior.
vigiarVersionNueva()

app.use(router)

app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      // `system` y no `.dark` porque es lo que lee Tailwind.
      //
      // Con `.dark` los dos marcos decidían por señales distintas: PrimeVue
      // esperaba la clase en `<html>` y Tailwind 4 usa `prefers-color-scheme`
      // porque no hay ningún `@custom-variant dark` en la hoja. Como nada en la
      // aplicación escribe esa clase, el tema de PrimeVue se quedaba siempre en
      // claro —fondo blanco— mientras Tailwind sí aplicaba sus variantes oscuras
      // si el sistema operativo estaba en oscuro. De ahí el texto claro sobre
      // fondo claro en las tablas: los dos estaban en modo distinto a la vez.
      //
      // Para que los dos sigan al mismo sitio, los dos tienen que leer la misma
      // señal. Añadir un interruptor de tema es otra cosa: requiere
      // `@custom-variant dark` y un interruptor que escriba la clase.
      darkModeSelector: 'system',
      cssLayer: {
        name: 'primevue',
        order: 'tailwind-base, primevue, tailwind-utilities',
      },
    },
  },
  ripple: true,
  inputStyle: 'filled',
  locale: esLocale,
})

app.directive('tooltip', Tooltip)

app.use(ToastService)
app.use(ConfirmationService)

app.mount('#app')